import React, { Component } from "react";
import { getStaticUrl } from "../../../../config";
import styled from "styled-components";
import Lottie from "react-lottie-player";
import fixedBlur from "./Fixed Blur.json";

const Container = styled.div`
    width: 100%;
    height: 100%;
    opacity: ${props => props.show ? 1 : 0};
    transition: opacity 1500ms;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
    
    video {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        object-fit: fill;
    }
    
    h2 {
        z-index: 2;
        text-shadow: rgba(0, 0, 0, 0.2) 0px 1px 0px;
    }
`;

export class AiGenerateProgress extends Component {
    render() {
        const { state = "entered", fontSize = 40, label = "Generating slide...", fit = "fill" } = this.props;

        return (
            <Container show={state == "entering" || state == "entered"}>
                {/*<video src={getStaticUrl("/images/ai3.mp4")} autoPlay loop muted style={{ objectFit: fit }} />*/}
                <Lottie loop animationData={fixedBlur} play
                    style={{
                        width: "300%",
                        height: "300%",
                        position: "absolute",
                        zIndex: 0,
                        opacity: 1,
                        transition: "opacity 500ms"
                    }}
                />
                {(label && label.length) && <h2 style={{ fontSize }}>{label}</h2>}
            </Container>
        );
    }
}
